import { render, staticRenderFns } from "./OrderViewActionLinkToInvoice.vue?vue&type=template&id=ee5eb5c0&"
import script from "./OrderViewActionLinkToInvoice.vue?vue&type=script&lang=js&"
export * from "./OrderViewActionLinkToInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports